<!-- 采购计划执行 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="queryData"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <!-- table -->
      <e-table-list :table-data="tableData" :table-label="tableLabel" :index-show="true">
        <template #code="tData">
          <eui-btn type="text" font-size="12px" @click="handleCodeDetail(tData.scope.row)">
            {{ tData.scope.row.purchasePlanCode }}
          </eui-btn>
        </template>
        <template #header>
          <span>操作</span>
          <el-tooltip class="item" effect="dark" placement="top-end">
            <div slot="content">
              未执行采购的采购计划可以退回，
              <br />
              部分采购的采购计划仅支持终止采购。
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #company="tData">
          <eui-btn
            v-if="tData.scope.row.purchaseModeType == 4"
            type="link"
            font-size="12px"
            @click="handleFinish(tData.scope.row)"
          >
            完成
          </eui-btn>

          <eui-btn type="link" font-size="12px" @click="handleExecute(tData.scope.row)">执行</eui-btn>

          <eui-btn
            v-if="tData.scope.row.isCanBack === 1"
            type="link"
            font-size="12px"
            @click="openDia('back', tData.scope.row)"
          >
            退回
          </eui-btn>

          <eui-btn
            v-if="tData.scope.row.isCanTerminate === 1"
            type="link"
            font-size="12px"
            @click="openDia('terminate', tData.scope.row)"
          >
            终止采购
          </eui-btn>

          <!-- <el-button type="text" @click="openDia('back', tData.scope.row)">退回</el-button>
          <el-button type="text" @click="openDia('terminate', tData.scope.row)">终止采购</el-button> -->
        </template>
      </e-table-list>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 选择审批流弹框 -->
    <e-dialog
      :dialog-title="'选择委托机构'"
      :center-dialog-visible="visible"
      :popup-width="'600px'"
      :is-show-cancel="false"
      @submitPopupData="submitPopupData"
      @resetPopupData="resetPopupData"
    >
      <el-radio-group v-model="radio">
        <el-radio v-for="item in radioList" :key="item.id" :label="item.id">
          {{ item.name }}
        </el-radio>
      </el-radio-group>
    </e-dialog>

    <!-- 弹窗提示 -->
    <prompt-modal :prompt-modal-visible="promptModalVisible" :footer="true" @close="closeDia">
      <div slot="title" class="prompt-modal-title">
        <!-- <img src="@/static/common/warnIcon.png" alt /> -->
        <p>{{ title }}</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>{{ content }}</h4>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia()">取消</el-button>
        <el-button v-prevent-re-click class="btn-80-30-primary" type="primary" @click="handleSure()">确定</el-button>
      </div>
    </prompt-modal>
  </div>
</template>

<script>
import PromptModal from '@/modules/projectA/components/common/promptModal.vue';
import {
  bidSysBaseUrl,
  bidDingUrl,
  oldMallBaseUrl,
} from '@/modules/projectA/api/config';
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import eDialog from '@/modules/projectA/components/common/e-dialog';
import Api from '@/modules/projectA/api/purchase';


export default {
  components: {
    eSearch,
    eTableList,
    eDialog,
    PromptModal,
  },
  data() {
    return {
      title: '',
      promptModalVisible: false,
      content: '',
      type: '',
      paramsRow: {},

      radio: null,
      radioList: [
        {
          name: '中国石化国际事业招标',
          id: 1,
        },
        {
          name: '中技国际招标机构',
          id: 2,
        },
      ],
      visible: false,
      tableData: [],
      pageTotal: 0,
      tableLabel: [
        {
          label: '采购计划编号',
          param: 'purchasePlanCode',
          width: '160',
          align: 'center',
          slot: 'code',
        },
        {
          label: '采购计划名称',
          param: 'purchasePlanName',
          align: 'center',
        },
        { label: '提交日期', param: 'submitTime', align: 'center' },
        { label: '创建人', param: 'createMemberName', align: 'center' },
        {
          label: '审核状态',
          align: 'center',
          render: (row) => {
            const obj = {
              0: '新建',
              1: '待审核',
              2: '审核通过',
              3: '审核驳回',
            };
            return obj[Number(row.purchasePlanStatus)];
          },
        },
        {
          label: '采购计划',
          param: 'purchaseModeType',
          align: 'center',
          render: (row) => {
            const obj = {
              1: '选品下单',
              2: '询比价',
              3: '自行招标',
              4: '委托招标',
              5: '执行框架协议',
            };
            return obj[Number(row.purchaseModeType)];
          },
        },
        {
          label: '操作',
          fixed: 'right',
          align: 'center',
          header: 'header',
          slot: 'company',
          width: 200,
        },
      ],
      queryData: {
        purchasePlanName: '',
        purchasePlanCode: '',
        createTime: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        purchaseModeType: null,
        pageNum: 1,
        pageSize: 10,
      },
      fieldList: [
        {
          label: '采购计划名称',
          type: 'input',
          value: 'purchasePlanName',
        },
        {
          label: '采购计划编号',
          type: 'input',
          value: 'purchasePlanCode',
        },
        {
          label: '提交时间',
          type: 'date',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          dateType: 'daterange',
        },
        {
          label: '采购计划',
          type: 'select',
          placeholder: '请选择',
          value: 'purchaseModeType',
          list: 'purchaseModeTypeList',
        },
      ],
      listTypeInfo: {
        purchaseModeTypeList: [
          { name: '选品下单', id: 1 },
          { name: '询比价', id: 2 },
          { name: '自行招标', id: 3 },
          { name: '委托招标', id: 4 },
          { name: '执行框架协议', id: 5 },
        ],
      },
    };
  },
  mounted() {
    this.purchasePlanExecutePage();
  },

  methods: {
    submitPopupData() {
      if (this.radio === 1) {
        const url =
          'https://ec.epec.com/BidRequestAction!toBidRequestActionAdd.do?pid=100&cid=101&index=0&isCookie=0&flag=nav';
        window.open(url);
        this.visible = false;
      }
    },
    // 采购计划执行接口
    async purchasePlanExecutePage() {
      const params = { ...this.queryData };
      delete params.createTime;
      const res = await Api.purchasePlanExecutePage(params);
      if (res.code == '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },
    // 执行
    async handleExecute(row) {
      switch (row.purchaseModeType) {
        case 3:
          this.goToBiddingUrl(row);
          break;
        case 4:
          // this.visible = true;
          const url = `${oldMallBaseUrl}/ecmall/externalLogin/loginPlatform.do?referer=${bidDingUrl}`;
          window.open(url);

          // if(process.env.NODE_ENV=== 'production'){
          //   window.open('https://mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://bidding.epec.com','_blank')
          // }else{
          //   window.open('https://uat-mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://10.230.196.49','_blank')
          // }
          break;
        default:
          const pathObj = {
            1: '/plan/purchaseWayExecute/choose?type=order', // 选品下单,
            2: '/enquiryManage/enquiryIss?type=purchasePlan', // 询比价,
            5: '/plan/purchaseWayExecute/choose?type=agreement', // 执行框架协议
          };
          this.$router.push({
            path: pathObj[row.purchaseModeType],
            query: { ...row },
          });
      }
    },

    goToBiddingUrl(row) {
      const pathData = `type=purchasePlan&purchasePlanId=${row.purchasePlanId}&budgetaryPrice=${row.budgetaryPrice}&expectedArrivalDate=${row.expectedArrivalDate}&createMemberName=${row.createMemberName}`;
      window.open(`${bidSysBaseUrl}/#/bidding/purchaseNewBidding?${pathData}`);
    },
    resetPopupData() {
      this.visible = false;
    },
    // 完成 跳委托招标
    handleFinish(row) {
      const content = '将该采购计划标记为完成采购，标记后该采购计划不可重复执行。操作不撤销，是否确认？';
      this.$alert(content, '完成确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async () => {
          const { purchasePlanId } = row;
          const res = await Api.biddingFinish({ purchasePlanId });
          if (res.code == '200') {
            this.queryData.pageNum = 1;
            this.purchasePlanExecutePage();
            this.$message.success('提交成功');
          }
        })
        .catch(() => {});
    },
    // 查询
    handleFilter(val) {
      this.queryData = val;
      this.queryData.pageNum = 1;
      this.queryData.submitTimeStart = val.createTime ? val.createTime[0] : '';
      this.queryData.submitTimeEnd = val.createTime ? val.createTime[1] : '';
      this.purchasePlanExecutePage();
    },
    // 重置
    handleReset(val) {
      this.queryData = this.$options.data().queryData;
      this.purchasePlanExecutePage();
    },
    // 分页
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.purchasePlanExecutePage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.purchasePlanExecutePage();
    },
    // 查看采购计划详情
    handleCodeDetail(row) {
      const { purchasePlanId } = row;
      this.$router.push({
        path: `/plan/purchaseQuery/purchaseDetail`,
        query: { purchasePlanId },
      });
    },
    // new
    openDia(type, row) {
      this.type = type;
      this.paramsRow = { ...row };
      if (type === 'back') {
        this.title = '退回确认';
        this.content = '退回后该采购计划不可执行采购，确认操作吗？';
      }
      if (type === 'terminate') {
        this.title = '终止采购确认';
        this.content = '终止采购后，该采购计划将无法继续执行，确认操作吗？';
      }
      this.promptModalVisible = true;
    },

    async handleSure() {
      const { purchaseCompanyId, purchasePlanId } = this.paramsRow;
      console.log(purchaseCompanyId, purchasePlanId);
      const res = await Api[this.type]({
        purchaseCompanyId,
        purchasePlanId,
      });
      if (res.code === '200') {
        if (this.type === 'back') {
          this.$message.success('退回成功');
        }
        if (this.type === 'terminate') {
          this.$message.success('终止采购成功');
        }
        this.purchasePlanExecutePage();
        this.closeDia();
      }
    },

    closeDia() {
      this.promptModalVisible = false;
      this.title = '';
      this.content = '';
      this.paramsRow = {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.icon-question {
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  color: #c5c5c5;
  display: inline-block;
  margin-left: 10px;
  &:hover {
    color: #fff;
    background-color: #c5c5c5;
  }
}
.search-box {
  padding: 10px 20px 10px 36px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.active-btn {
  background: #ccc;
}
::v-deep .el-radio-group {
  display: flex;
  flex-direction: column;
}
::v-deep .el-radio {
  margin-bottom: 14px;
}

.prompt-modal-title {
  display: flex;
  height: 40px;
  padding-left: 20px;
  align-items: center;

  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    vertical-align: middle;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: $c3;
    line-height: 14px;
  }
}

.prompt-modal-content {
  > h4 {
    font-weight: 500;
    color: $c3;
    margin-bottom: 5px;
  }
}
::v-deep .el-table {
  th.el-table__cell > .cell {
    font-weight: normal;
    font-size: 14px;
  }
}
.pagination-box {
  text-align: right;
}
</style>
